// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { ReservedImport } from "../models/ReservedImport";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type ImportsData = ReservedImport;

/** Params the client supplies at subscribe time. */
export type ImportsParams = Record<string, never>;

export class ImportsChannel extends Channel<ImportsParams, ImportsData> {
  static identifier = "ImportsChannel";
}
